import 'css-chunksrc/client/common/filterMenu/resourceTags/styles.scss';export default {
  "header": "_header_50p91_1",
  "icon": "_icon_50p91_10",
  "title": "_title_50p91_18",
  "list": "_list_50p91_25"
};